import { ClipboardCheckIcon, MicroscopeIcon, ShieldCheckIcon, ShowerHeadIcon, ThermometerIcon, WheatIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'Food Science & Technology Fundamentals: Food Composition, Quality & the Food Plant',
    summary: 'A visual technical reference to food composition, water activity and pH, why food spoils, preservation principles, quality attributes and how a food plant is organized.',
    icon: WheatIcon,
  },
  {
    number: '02',
    title: 'Food Processing Unit Operations: Thermal Processing, Chilling & Freezing, Drying, Mixing & Packaging',
    summary: 'A visual technical reference to pasteurization, sterilization and retorts, cooling and freezing, drying, mixing, filling and packaging.',
    icon: ThermometerIcon,
  },
  {
    number: '03',
    title: 'Plant Hygiene & Sanitation: Hygienic Design, Cleaning & Disinfection and CIP Systems',
    summary: 'A visual technical reference to hygienic design, personal hygiene, cleaning chemistry, the wet cleaning sequence, CIP circuits and cleaning verification.',
    icon: ShowerHeadIcon,
  },
  {
    number: '04',
    title: 'Food Microbiology & Hazard Control: Pathogens, Spoilage and Biological, Chemical & Physical Hazards',
    summary: 'A visual technical reference to microbial growth, the main foodborne pathogens, environmental monitoring and biological, chemical and physical hazards.',
    icon: MicroscopeIcon,
  },
  {
    number: '05',
    title: 'Food Safety Systems: HACCP, Prerequisite Programs, Allergen Management, Traceability & Recall',
    summary: 'A visual technical reference to prerequisite programs, the HACCP steps and principles, allergen control, traceability and recall.',
    icon: ShieldCheckIcon,
  },
  {
    number: '06',
    title: 'Food Quality Control, Inspection, Audits & Continuous Improvement',
    summary: 'A visual technical reference to specifications, sampling, in-process checks, metal detection and X-ray, SPC, root cause analysis, audits and continuous improvement.',
    icon: ClipboardCheckIcon,
  },
];
